import { render, staticRenderFns } from "./AddUserCompanyPage.vue?vue&type=template&id=04ab07c6&"
import script from "./AddUserCompanyPage.vue?vue&type=script&lang=js&"
export * from "./AddUserCompanyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04ab07c6')) {
      api.createRecord('04ab07c6', component.options)
    } else {
      api.reload('04ab07c6', component.options)
    }
    module.hot.accept("./AddUserCompanyPage.vue?vue&type=template&id=04ab07c6&", function () {
      api.rerender('04ab07c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/AddUserCompanyPage.vue"
export default component.exports